import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="text-light py-4 mt-auto mt-4" style={{ backgroundColor: 'var(--primary-dark-text)' }}>
      <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <p className="mb-2 mb-md-0">
          &copy; {new Date().getFullYear()} Renovestim. Tous droits réservés.
        </p>
        <div className="d-flex gap-3">
          <Link to="/mentions-legales" className="text-light text-decoration-none">
            Mentions légales
          </Link>
          <Link to="/politique-confidentialite" className="text-light text-decoration-none">
            Politique de confidentialité
          </Link>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
